export default class ContactCallGateway {
  constructor({ csrfToken, searchPath }) {
    this.csrfToken = csrfToken;
    this.searchPath = searchPath;
  }

  async search(postalcode) {
    const formData = new FormData();
    formData.append('search_form[postalcode]', postalcode);

    const response = await fetch(this.searchPath, {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json; charset=utf-8',
        'X-CSRF-Token': this.csrfToken,
      },
    });

    if (response.ok) {
      const responseBody = await response.json();
      if (responseBody.redirectUrl) {
        return { success: true, redirectUrl: responseBody.redirectUrl };
      } else {
        return { success: false, errors: responseBody.errors };
      }
    }

    return { success: false };
  }
}
